import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function BestEnterprise({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: '集视医疗获远毅资本天使轮投资，为2700万全年龄段弱视患者提供基于XR技术的视觉训练方法',
      date: '2024-08',
      desc: '苏州集视医疗科技有限公司（简称“集视医疗”）宣布完成由远毅资本独家投资的天使轮融资。资金将用于其自研的基于混合现实XR技术的视觉训练方法的研发与落地。',
      img: '/images/news/news6.png',
      route: '/newsInfo/invest'
    },
    {
      title: 'ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗',
      date: '2024-08',
      desc: '复旦大学附属眼耳鼻喉科医院眼科孙兴怀教授、刘红主任、文雯博士与美国加州大学的李响博士合作，将增强现实和双眼训练相结合，研发了一种双眼分视的训练新模式并用于成年弱视…',
      img: '/images/news/arvo1.png',
      route: '/newsInfo/arvo'
    },
    {
      title: '深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕',
      date: '2026-06-07',
      desc: '6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！',
      img: '/images/news/twoCitiesAcademic2.jpg',
      route: '/newsInfo/twoCitiesAcademic'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 卓悦榜丨集视医疗荣膺“年度智慧医疗最佳企业”奖项</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.04.26</span>
              </div>
              <div className="article_titleBottom">卓悦榜丨集视医疗荣膺“年度智慧医疗最佳企业”奖项</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                2024年4月26日，浩悦资本正式发布了“2024第八届医疗健康投资卓悦榜”，集视医疗荣膺“年度智慧医疗最佳企业”奖项。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/bestEnterprise1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                作为业界高度认可的年度权威榜单，医疗健康投资卓悦榜自2017年首次发榜八年以来，始终秉承公平公正、客观中立的原则，针对创新医药、创新医疗器械、IVD与智慧医疗、健康服务、智慧医疗、生命科技等不同领域的医疗健康优秀企业授予奖项， 旨在打造真正具有公信力和影响力的投资榜单，为行业发展树立新标杆，为投资合作创造新机遇。集视医疗自成立以来深耕于弱视、干眼和眼末端疾病患者的需求，以产学研联动为抓手，致力于常见眼病治疗与防控的整体解决方案的高新技术企业。 公司产品已覆盖弱视、青少年儿童近视防控、干眼防治，并在弱视治疗领域的数字疗法形成了几十项自主知识产权。2022-2024年期间，公司累计获得远毅资本、复星集团等医疗领域巨头资本数千万投资。共荣获30余项奖励，和中国科学院、复旦大学附属眼耳鼻喉科医院达成深度战略合作，承担重大课题研究任务。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/bestEnterprise2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                风物长宜放眼量。中国医疗健康行业虽处在调整周期，每年却仍有着超千例融资交易发生，一例例开拓创新疆界的产业升级案例仍在不断浮现。正因此，集视医疗将持续秉持患者需求至上，创新精准医疗的价值观， 以脑科学研究为基础载体运用领先的物联网、人工智能与大数据云计算技术，打通院内外及患者全时空全病程数据，全面赋能眼科疾病的诊断、治疗及诊后管理。致力于成为全球顶尖的脑科学机制研究驱动的眼科诊疗平台。 大道不孤，众行致远，集视医疗期待和浩悦资本及其他产业同仁携手共进，穿越周期，共同谱写中国医疗健康事业高质量发展的时代画卷。
              </div>
            </div>
          </div>
          <div className="article_content">
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/pre'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/invest'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/pre'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/invest'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
